import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";

export const getTankListBySite = createAction(
  "[Warehouses] Get All Warehouses By Site Action",
  props<{ siteCode: string; pageReq?: PaginationRequest }>()
);
export const loadTankListBySite = createAction(
  "[Warehouses] Load All Warehouses By Site Action",
  props<{ response: any[] }>()
);
export const setLoadingTanksLoadStart = createAction(
  "[Warehouses] Load Warehouses Start Action"
);
export const setLoadingTanksLoadEnd = createAction(
  "[Warehouses] Load Warehouses End Action"
);
export const resetTanks = createAction("[Warehouses] Reset Warehouses Action");
